import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTE_BY_PATH } from './routes'

/**
 * The prototype addressed screens by `location.hash` (#dashboard, #candidates).
 * Anyone with a bookmark — and the old post-login redirect target
 * `/index.html#dashboard` — must not dead-end after the cutover.
 *
 * Runs once. StrictMode's double-invoke is harmless because the navigation is
 * `replace` and the second run finds no hash left to act on.
 */
export default function LegacyHashRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    const route = (window.location.hash || '').slice(1)
    if (route && ROUTE_BY_PATH[route]) {
      navigate(`/${route}`, { replace: true })
    }
  }, [navigate])

  return null
}
